import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper';
import "swiper/swiper-bundle.css";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

//import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';

import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

/*
function onTidioChatApiReadyChangeZIndex() {
  (function() {
    const tidioChatIframe = document.getElementById('tidio-chat-iframe');
    if (tidioChatIframe) {
      tidioChatIframe.style.zIndex = '100';
    }
  })();
}
if (window.tidioChatApi) {
  window.tidioChatApi.on("ready", onTidioChatApiReadyChangeZIndex);
} else {
  document.addEventListener("tidioChat-ready", onTidioChatApiReadyChangeZIndex);
}*/


window.addEventListener('popstate', function(event) {
  // Prevent the default behavior of the popstate event, which is to navigate to the previous page
  event.preventDefault();

  // Now you can perform actions without a page reload
  // For example, show a specific section, update content, etc.
});

if (document.querySelectorAll('.swiper-instagram').length > 0) {
  let swiper4 = new Swiper(".swiper-instagram", {
    loop: true,
    navigation: {
      nextEl: ".swiper-progs-button-next",
      prevEl: ".swiper-progs-button-prev",
    },
    pagination: {       
      el: '.swiper-pagination',
      clickable: true,
    },
    spaceBetween: 10,
    breakpoints: {
      319: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      991: {
        slidesPerView: 4, 
        spaceBetween: 0
      }
    }
  });
}

if (document.querySelectorAll('.swiper-carousel').length > 0) {
  let swiper3 = new Swiper(".swiper-carousel", {
    loop: true,
    navigation: {
      nextEl: ".swiper-progs-button-next",
      prevEl: ".swiper-progs-button-prev",
    },
    pagination: {       
      el: '.swiper-pagination',
      clickable: true,
    },
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      991: {
        slidesPerView: 4, 
        spaceBetween: 20
      }
    }
  });
}

if (document.querySelectorAll('.swiper-mainslider').length > 0) {
  let swiper2 = new Swiper(".swiper-mainslider", {
    loop: true,
    effect: 'fade', 
    navigation: {
      nextEl: ".swiper-progs-button-next",
      prevEl: ".swiper-progs-button-prev",
    },
    pagination: {       
      el: '.swiper-pagination',
      clickable: true,
    },
    spaceBetween: 0,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      769: {
        slidesPerView: 1, 
        spaceBetween: 0
      }
    }
  });
}
if (document.querySelectorAll('.swiper-gallery').length > 0) {
  
  let swiperSmall = new Swiper(".swiper-gallery-small", {
     
    pagination: {       
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
    
    slidesPerView:1,
    spaceBetween: 10,
    breakpoints: {
      319: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      991: {
        slidesPerView: 4, 
        spaceBetween: 10
      },
      1201: {
        slidesPerView: 6, 
        spaceBetween: 10
      }
    }
  });
  let swiper1 = new Swiper(".swiper-gallery", {
    loop: true,
    effect: 'fade', 
    navigation: {
      nextEl: ".swiper-progs-button-next",
      prevEl: ".swiper-progs-button-prev",
    },
    spaceBetween: 0,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      769: {
        slidesPerView: 1, 
        spaceBetween: 0
      }
    }
  });
}

$("document").ready(function () {
 
  /*
  function checkAndRedirect() {
      if ($('body:contains("Az Ön kupon kódja a következő:")').length > 0) {
          window.location.href = 'https://richmondinteriors.hu/koszonjuk-hogy-feliratkozott-hirlevelunkre/';
      }
  }
  $(document).on('change', checkAndRedirect);*/
  $(window).on('scroll', function(event) {
    if ($(window).scrollTop() > 0) {
      $('header').addClass('scrolling');
 
    } else {
      $('header').removeClass('scrolling');

    }
      event.preventDefault(); 
  });

  if ($('.formSubmit').length > 0) {
    $('.formSubmit').click(function (e) {
      let form = e.target.closest('form');
      form.submit();
      return false;
    });
  }
  
  if ($('#galleries').length > 0) {
    console.log('start');
    lightGallery(document.getElementById('galleries'), {
        plugins: [lgZoom, lgThumbnail],
        speed: 500,
        licenseKey: 'A66FBFD3-F846-4DC0-A642-9B68BE2DF897',
        selector: '.imageBox'
    });
  }

  if ($('.megaMenu').length > 0) { // menu functions
    $('.menuRight .profile').click(function () {
      if ($(window).width() > 990) {
        if ($(this).hasClass('hasName')) {

          if ($('.profileMenu').length > 0) {
            $('.profileMenu').toggle();
          }
          return false;
        }
      }
    });
    function hasNumber(myString) {
      return /\d/.test(myString);
    }
    $('.hamburger').click(function () {
      $('.megaMenu').slideToggle();
      $('body').toggleClass('active');
      return false;
    });

    $('.primaryMobileMenu h4').click(function () {
      $(this).parent().find('.mobileToggle').slideToggle();
      return false;
    });
    $('.primaryMobileMenu li.menu-item-has-children a').click(function () {
      var what = $(this).parent().prop('className').split(' ');
      var theTarget = "";
      for (let i = 0; i < what.length; i++) {
        if (hasNumber(what[i])) {
          theTarget = what[i].replace('menu-item-', '#dropdown-');
          
        }
      }
      if (theTarget) {
        $('.dropdown').hide();
        $(theTarget).show();
      }
      return false;
    });
    $('.megaMenu .close').click(function () {
      $('body').removeClass('active');
      $('.megaMenu').hide();
      $('.dropdown').hide();
      return false;
    });
    $('.closeMobile').click(function () {

      $('.dropdown').hide();
      return false;
    });

    $('.headerMiddle').hover(function () {
      if ($(window).width() > 990) {
        $('.dropdown').hide();
      }
    }, function () { });
    $('.headerBottom li a').hover(function () {
      if ($(window).width() > 990) {
        var what = $(this).parent().attr('id').replace('menu-item', '#dropdown');
        if ($(this).parent().hasClass('menu-item-has-children')) {
          $('.dropdown').hide();
          $(what).show();

        } else {
          $('.dropdown').hide();
        }
      }
    }, function () {

    });
    $('.inside ul li a.hasChildren').click(function () {
      $(this).parent().find('ul').slideToggle();
      return false;
    });
    $('.dropdown').hover(function () { }, function () {
      if ($(window).width() > 990) {
        $('.dropdown').hide();
      }
    });
  }
  if ($('.accordion-trigger').length > 0) {
    $('.accordion-trigger').click(function () {
      $(this).parent().find('.footerMenu').slideToggle();
      return false;
    });
  }


  function copyToClipboard(text) {
    var dummy = document.createElement("textarea");
    document.body.appendChild(dummy);        
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  }
  
  if ($('.copyURL').length > 0) {
    $('.copyURL').click(function() {
      var copyText = $(this).attr('href');
      copyToClipboard(copyText);
      return false;
    });
  }


  if ($('.shareTrigger').length > 0) {
    $('.shareTrigger').click(function () {
      $(this).hide();
      $(this).parent().find('ul').show();
      return false;
    });
  }

  if ($('.addToCartBox').length > 0 || $('.kedvenceklist').length>0) {
    function add_to_cart_function(product_id, quantity, nonce) {

      $.ajax({
        type: 'post',
        url: `${window.location.origin}/wp-admin/admin-ajax.php`,

        data: {
          action: 'custom_ajax_add_to_cart',
          nonce: nonce,
          product_id: product_id,
          quantity: quantity          

        }
      }).done(function (resp) {
    
        $('.addToCartBox .wloader').hide();

        $('.successMessage').show();
        var currentNumber = $('.header .cart .number').text().trim(); 
        if (!currentNumber || isNaN(currentNumber)) { 
          $('.header .cart .number').text(parseInt(quantity)); 
        } else {
          $('.header .cart .number').text(parseInt(currentNumber) + parseInt(quantity)); 
        }
        $('.header .cart .number').show();
        
        

        if($('.kedvenceklist').length>0){
     
          $('.addToCartBtn a').parent().find('.wloader').hide();

        }
        $('.addToCartBtn a').bind('click',function() {
      
          var product_id = $(this).data('product_id');
          var quantity = $(this).data('quantity') || 1;
          $('.addToCartBox .wloader').show();
          if($('.kedvenceklist').length>0){
            var productName = $(this).data('name');
            $('#productName').text(productName);
            $(this).parent().find('.wloader').show();
          }
         // $('.successMessage').hide();
         var nonce = $(this).data('nonce')
         add_to_cart_function(product_id, quantity, nonce);
    
          return false;
        }); 
      }).fail(function (resp) {

      }).always(function () {

      });
    }
    $('.addToCartBtn a').click(function() {

      var product_id = $(this).data('product_id');
      var quantity = $(this).data('quantity') || 1;
      $('.addToCartBox .wloader').show();
      if($('.kedvenceklist').length>0){
        var productName = $(this).data('name');
        $('#productName').text(productName);
        $(this).parent().find('.wloader').show();
      }
     // $('.successMessage').hide();
     var nonce = $(this).data('nonce')
     add_to_cart_function(product_id, quantity, nonce);

      return false;
    }); 
    $('.addToCartBox input').val('1');
    $('.addToCartBox .minus').click(function () {
      var current = $(this).parent().find('.field input').val();
      /*var currentURL = $('.addToCartBtn a').attr('href');
      currentUrl = currentURL.split('quantity=')[0] + 'quantity=';*/
      if (current == 1) {
        current = 1;
      } else {
        current--;
      }
      $('.addToCartBox input').val(current);
      $('.addToCartBtn a').data('quantity',current);
      //$('.addToCartBtn a').attr('href', currentUrl + current);

      return false;
    });
    $('.addToCartBox .plus').click(function () {
      var current = $(this).parent().find('.field input').val();
      /*var currentURL = $('.addToCartBtn a').attr('href');
      currentUrl = currentURL.split('quantity=')[0] + 'quantity=';*/
      current++;

      $('.addToCartBox input').val(current);
      $('.addToCartBtn a').data('quantity',current);
      //$('.addToCartBtn a').attr('href', currentUrl + current);

      return false;
    });
  }
  
  if ($('.accordion').length > 0) {
    $('.accordionHeader').click(function () {
      $(this).parent().toggleClass('active');
      $(this).parent().find('.accordionContent').slideToggle();


      return false;
    });
  }

  
  if ($('.order-total').length > 0) {
    //.woocommerce table.shop_table td.product-price
  }
  if ($('.printBtn').length > 0) {
    $('.printBtn').click(function () {
      window.print();
      return false;
    });
  }

  if ($('.delete_user').length > 0) {
    $(".delete_user").click(function () {
      var user_id = $(this).data('id');
      var security = $(this).data('security');
      var redirect = $(this).data('redirect');

      $.ajax({
        type: 'post',
        url: `${window.location.origin}/wp-admin/admin-ajax.php`,

        data: {
          action: 'delete_user_action',
          user_id: user_id,
          security: security

        }
      }).done(function (resp) {
        if (resp == 'deleted_successfully') {
          window.location.href = redirect;
        }

      }).fail(function (resp) {

      }).always(function () {

      });

      /*
        var data = {
                'action': 'delete_user_action',
                'user_id': current_element_var.attr('delete-user-id'),
                'security': '<?php echo wp_create_nonce( "security-special-string" ) ?>'
        };
        $.post('<?php echo admin_url( 'admin-ajax.php' ) ?>', data, function(response) {
                if (response == 'deleted_successfully') {
                        current_element_var.hide();
                        current_element_var.after('<span> User Deleted Successfully </span>');
                        current_element_var.remove();
                }
        });*/

      return false;

    });
  }




  //Checkout

  if ($('#billing_company_field').length > 0) {
    if ($('body').hasClass('woocommerce-checkout')) { // checkout page 
      $('#billing_company_field').hide();
      $('#billing_tax_number_field').hide();
      $('.select-ceg-tipus input#magan').prop('checked', 'true');
      $('.select-ceg-tipus input').click(function () {

        var what = $(this).attr('id');
        if (what == "ceg") {
          $('#billing_company_field').show();
          $('#billing_tax_number_field').show();

        } else {
          $('#billing_company_field').hide();
          $('#billing_tax_number_field').hide();
        }
      });
    }

  } // end of Checkout 
  if ($('.add-to-wishlist').length > 0) {
    $('.add-to-wishlist').bind('click', function () {
      product = $(this).data('product');

      todo = '';
      
      
      if ($(this).hasClass('active')) {
        if ($(this).hasClass('refresh')) {
          todo = "refresh"; 
          $(this).removeClass('active');
        } else {
          todo = "remove";
          $(this).removeClass('active');
        }
      } else {
        todo = "add";
        $(this).addClass('active');
      }
      $(this).find('.wloader').css('display', 'block');

     // if ($('body').hasClass('logged-in')) { // loggedin
        toggle_wishlist(product, todo);

      //} else {
        wishlist_localstorage(product, todo);
      //}


      return false;
    });
    if($('.productTopSection').length>0) {
      if ($('body').hasClass('logged-in')) {

      } else {
        var getCurrentWishlist = localStorage.getItem('localwishlist');
        
        if (getCurrentWishlist !== null && getCurrentWishlist !== "") {
          var getCurrentWishlistArray = getCurrentWishlist.split(',');
        
          for (let i = 0; i < getCurrentWishlistArray.length; i++) {                        
              $('#wishlist-'+getCurrentWishlistArray[i]).addClass('active');            
          }
        }
      }
    }
 

  }
  if ($('.kedvenceklist').length > 0) {
    // if not logged in
    //let currentWishlist = localStorage.getItem('localwishlist');
    // localStorage.removeItem("localwishlist");
    var product = '';
    var todo = '';
    
    if($('#input_6_2').length>0) {
      let currentWishlist = localStorage.getItem('localwishlist');
      if(currentWishlist) {
        $('#input_6_2').val(currentWishlist);
      } else {
        $('.sendBtn').hide();
      }
      
    }
   
    $('.remove-from-wishlist').bind('click', function () {
   
      $(this).find('.wloader').css('display', 'block');
      $('.preloader').css('display', 'block');
      product = $(this).data('product');

      todo = 'refresh';

      if ($('body').hasClass('logged-in')) { // loggedin
        wishlist_localstorage(product, todo);
        toggle_wishlist(product, todo);

      } else {
        

        let currentWishlistToLoad = localStorage.getItem('localwishlist');
         
       
        wishlist_localstorage(product, "remove");
        toggle_wishlist(currentWishlistToLoad, 'loggedout');


      }


      return false;
    });


      //printBtnLink
      var getUrlParameterNew = function getUrlParameterNew(sParam) {
        var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
        }
        return false;
      };
      var printing = getUrlParameterNew('print');
      if (printing) {
        if (printing == "true") {
          window.print();
        }
      }
      $('.preloader').css('display', 'none');
    

  

      if ($('body').hasClass('logged-in')) {
     
      } else {
        var getCurrentWishlist = localStorage.getItem('localwishlist');
      
        toggle_wishlist(getCurrentWishlist, 'loggedout');
      }
    

  }
  function wishlist_localstorage(product, todo) {
    let currentWishlist = localStorage.getItem('localwishlist');
   
    let index = '';

    if (currentWishlist !== null && currentWishlist !== "") {

      //localStorage.removeItem("localwishlist");
      if (todo == "add") {
        currentWishlistArray = currentWishlist.split(',');
       // console.log(currentWishlistArray);
       // console.log(product);
        index = currentWishlistArray.indexOf(String(product));
       // console.log(index);
        if (index == -1) {
       //   console.log(currentWishlist);
          currentWishlist += ',' + product;
        //  console.log(currentWishlist);
          //localStorage.removeItem("localwishlist");
          localStorage.setItem('localwishlist', currentWishlist);
        }
      //  console.log('add ' + currentWishlist);
      } else {
        currentWishlist = currentWishlist.split(',');
        index = currentWishlist.indexOf(String(product));

        currentWishlist.splice(index, 1);

        currentWishlist = currentWishlist.join(',');

        // localStorage.removeItem("localwishlist");
        localStorage.setItem('localwishlist', currentWishlist);
        
      }
    } else {
      localStorage.setItem('localwishlist', product);
     // console.log(localStorage.getItem('localwishlist'));
    }
    /*$('.wloader').css('display', 'none');
    $('.wloader').fadeOut();*/

  }
  function toggle_wishlist(product, todo) {

    
    $.ajax({
      type: 'post',
      url: `${window.location.origin}/wp-admin/admin-ajax.php`,

      data: {
        action: 'toggle_wishlist',
        product: product,
        todo: todo

      }
    }).done(function (resp) {
    
      $('#results').html(resp);
      $('.wloader').css('display', 'none');
      $('.preloader').css('display', 'none');
      if (todo == "refresh") {
     
        $('.remove-from-wishlist').bind('click', function () {
          $(this).find('.wloader').css('display', 'block');
          $('.preloader').css('display', 'block');
          product = $(this).data('product');
    
          todo = 'refresh';
       
         
         // if ($('body').hasClass('logged-in')) { // loggedin
            toggle_wishlist(product, todo);
    
          //} else {
            wishlist_localstorage(product, "remove");
          //}
    
    
          return false;
        });
      } else if(todo=="loggedout") {
        
    
        
        $('.remove-from-wishlist').bind('click', function () {
         
          $(this).find('.wloader').css('display', 'block');
          $('.preloader').css('display', 'block');
        
          product = $(this).data('product');
          
          let currentWishlistToLoad = localStorage.getItem('localwishlist');
          if (currentWishlistToLoad !== null && currentWishlistToLoad !== "") {
            currentWishlistToLoad = currentWishlistToLoad.split(',');
            index = currentWishlistToLoad.indexOf(String(product));

            currentWishlistToLoad.splice(index, 1);

            currentWishlistToLoad = currentWishlistToLoad.join(',');

            // localStorage.removeItem("localwishlist");
            localStorage.setItem('localwishlist', currentWishlistToLoad);
            toggle_wishlist(currentWishlistToLoad, 'loggedout');
          }
        
          
    
    
          return false;
        });
      }
      
      
          if($('.kedvenceklist').length>0) {
        
            $('.addToCartBtn a').bind('click',function() {
        
              var product_id = $(this).data('product_id');
              var quantity = $(this).data('quantity') || 1;
              $('.addToCartBox .wloader').show();
              if($('.kedvenceklist').length>0){
                var productName = $(this).data('name');
                $('#productName').text(productName);
                $(this).parent().find('.wloader').show();
              }
            // $('.successMessage').hide();
            var nonce = $(this).data('nonce')
            add_to_cart_function(product_id, quantity, nonce);
        
              return false;
            }); 
          }
      
     
      
      /*else {
        $('.add-to-wishlist').bind('click', function () {
          product = $(this).data('product');
          todo = "remove";
          $(this).find('.wloader').css('display', 'block');
          wishlist_localstorage(product, todo);
          $(this).parent().parent().parent().hide();
          return false;
        });

      }*/

      $('.wloader').css('display', 'none');
      $('.wloader').fadeOut();

    }).fail(function (resp) {

    }).always(function () {

    });

  }
  

  if ($('.filterBar').length > 0) { // Filters
    var isLoading = true; 
    var stopScrolling = true; 
    $('.filterOverlay').click(function () {
      $('.filterBox').hide();
      $('.filterOverlay').hide();
      $('.filterTrigger').removeClass('active');
      return false;
    });
    $('.filterTrigger').click(function () {
      
      $('.filterBox').hide();
      
      if ($(this).hasClass('active')) {
        $('.filterOverlay').hide();
      } else {
        $(this).siblings('.filterBox').slideToggle();
        if($(window).width()>990) {
          $('.filterOverlay').show();
        }
        
      }
      $(this).toggleClass("active");

      return false;
    });
    
    $('.resetFilter').click(function () {
      $('.filterHelper').data('labszine', '');
      $('.filterHelper').data('forgofunkciok', '');
      $('.filterHelper').data('ulesmagassag', '');
      $('.filterHelper').data('felulet', '');
      $('.filterHelper').data('szin', '');
      
      if($(this).hasClass('resetArchive')) {
        $('.filterHelper').data('kategoria', originalCategories);
      } else {
        $('.filterHelper').data('kategoria', '');
      }
      
      $('.filterHelper').data('min', '0');
      $('.filterHelper').data('max', '2000000');
      $('.filterHelper').data('sort', 'NEW');
      $('.filterHelper').data('paged', '1');
      isLoading = true; 
      $('.filterBox a').removeClass('active');
      toggle_filter('filter');
      $(this).parent().hide();
      return false;
    });

    $('.orderNav .current').click(function () {
      $(this).siblings('.orderDropdown').slideToggle();

      return false;
    });
    $('.orderNav a').click(function () {
      var what = $(this).data('filter');
      var target = $(this).data('target');
      var text = $(this).text();
      $('.filterHelper').data(target, what);
      $('.orderNav .current .text').html(text);
      $('.orderDropdown').slideToggle();
      $('.filterHelper').data('paged', '1');
      stopScrolling = true;
      isLoading = true; 
      toggle_filter('filter');

      return false;
    });
    
    $('.filterBox a').click(function () {
      var what = $(this).data('filter');
      var target = $(this).data('target');
      if($(this).hasClass('filterBoxArchiveLink')) {
        $(this).toggleClass('active');
        var theTargets = [];
        var theTargetsString = '';
        $('.filterBoxArchive a.active').each(function() {
          
          theTargets.push($(this).data('filter')); 
        });
        theTargetsString = theTargets.join(",");
        $('.filterHelper').data(target, theTargetsString);
      } else {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
  
          var prev = $('.filterHelper').data(target);
          console.log(prev);
          var prevArray = [];
          if (prev) {
  
            prevArray = prev.split(',');
  
            if (prevArray.includes(what)) {
  
            } else {
              prev += "," + what;
              $('.filterHelper').data(target, prev);
            }
          } else {
            $('.filterHelper').data(target, what);
          }
        } else {
  
          var prev = $('.filterHelper').data(target);
          var prevArray = [];
  
          prevArray = prev.split(',');
          if (prevArray.includes(what)) {
            prevArray = prevArray.filter(item => item !== what);
            what = prevArray.join(',');
            $('.filterHelper').data(target, what);
          }
  
        }
      }
     

      
      return false;
    });

    $('.categoryFilter').click(function () {
      if ($(window).width() <= 990) {
        var what = $(this).data('filter');
        var target = $(this).data('target');
        
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {

          var prev = $('.filterHelper').data(target);

          var prevArray = [];
          if (prev) {

            prevArray = prev.split(',');

            if (prevArray.includes(what)) {

            } else {
              prev += "," + what;
              $('.filterHelper').data(target, prev);
            }
          } else {
            $('.filterHelper').data(target, what);
          }
        } else {

          var prev = $('.filterHelper').data(target);
          var prevArray = [];

          prevArray = prev.split(',');
          if (prevArray.includes(what)) {
            prevArray = prevArray.filter(item => item !== what);
            what = prevArray.join(',');
            $('.filterHelper').data(target, what);
          }

        }
        return false;
      }
      
    });
    $('.closePopupBox').click(function () {
      $(this).parent().hide();
      return false;
    });

    $('.triggerCategory').click(function () {
      if ($(window).width() <= 990) {
        $('.childrenBar').show();
      }
      return false;
    });
    $('.triggerSzurok').click(function () {
      if ($(window).width() <= 990) {
        $('.filterBar').show();
      }
      return false;
    });
    $('.applySzuro').click(function () {
      if ($(window).width() <= 990) {
        $('.filterBar').hide();
        $('.childrenBar').hide();
      }
      $('.filterBox').hide();
      $('.resetFilterBox').show();
      isLoading = true; 
      $('.filterHelper').data('paged', '1');
      stopScrolling = true;
      toggle_filter('filter');
      return false;
    });
    if ($(window).width() >= 990) {
      var waypoint = new Waypoint({
        element: document.getElementById('filterBar'),
        handler: function (direction) {
          if (direction == "up") {
            $('.filterFiller').removeClass("active");
            $('.filterBar').removeClass("active");
          } else {
            $('.filterFiller').addClass("active");
            $('.filterBar').addClass("active");
          }
        },
        offset: '190px'
      })
    }



  var formatSlider = document.getElementById('price-slider');
  var formatForSlider = {
      from: function (formattedValue) {
          return Number(formattedValue);
      },
      to: function(numericValue) {
          return Math.round(numericValue);
      }
  };
  // priceTop const local
  
  noUiSlider.create(formatSlider, {
      start: ['0', priceTop],
      range: {
          'min': 0,
          'max': priceTop
      },
      format: formatForSlider
  });


    var formatValues = [
        document.getElementById('formatting-start'),
        document.getElementById('formatting-end')
    ];
    $("#price-range").text("0 Ft - "+priceTop+" Ft");
    formatSlider.noUiSlider.on('update', function (values, handle, unencoded) {
      
        $("#price-range").text(values[0] + " Ft - " + values[1] + " Ft");
        $('.filterHelper').data('min', values[0]);
        $('.filterHelper').data('max', values[1]);
    });


    let eventBound = false;
    var scrollingStatus = 1;
    
    function toggle_filter(type) {
      
      $('.preloader').show();
      var current = $('.filterHelper').data('current');
      var maxpost = $('.filterHelper').data('maxpost');
      var paged = $('.filterHelper').data('paged');
   
      var sort = $('.filterHelper').data('sort');
      var min = $('.filterHelper').data('min');
      var max = $('.filterHelper').data('max');
      var szin = $('.filterHelper').data('szin');
      var labszine = $('.filterHelper').data('labszine');
      var forgofunkciok = $('.filterHelper').data('forgofunkciok');
      var ulesmagassag = $('.filterHelper').data('ulesmagassag');
      var felulet = $('.filterHelper').data('felulet');
      var kategoria = $('.filterHelper').data('kategoria');
      var taxonomy = $('.filterHelper').data('taxonomy');
      var slug = $('.filterHelper').data('slug');
      var product = '';
      var todo = '';
      
      $.ajax({
        type: 'post',
        url: `${window.location.origin}/wp-admin/admin-ajax.php`,

        data: {
          action: 'toggle_filter',          
          type: type,
          current: current,
          paged: paged,
          maxpost: maxpost,
          sort: sort,
          min: min,
          max: max,
          szin: szin,
          labszine: labszine,
          forgofunkciok: forgofunkciok,
          ulesmagassag: ulesmagassag,
          felulet: felulet,
          kategoria: kategoria,
          taxonomy : taxonomy,
          slug : slug
          

        }
      }).done(function (resp) {
        isLoading = false;
        
        if ($('body').hasClass('logged-in')) {

        } else {

          setTimeout(function() {
              var getCurrentWishlist = localStorage.getItem('localwishlist');
              
              if (getCurrentWishlist !== null && getCurrentWishlist !== "") {
                var getCurrentWishlistArray = getCurrentWishlist.split(',');
                for (let i = 0; i < getCurrentWishlistArray.length; i++) {                        
                    $('.product-'+getCurrentWishlistArray[i]).find('.add-to-wishlist ').addClass('active');            
                }
              }
              
          }, 100); // 1000 milliseconds = 1 second
          
          }
        if (resp.indexOf('ended') !== -1) {
         
          scrollingStatus = 1;
        } else {
      
          scrollingStatus = 0;
        }
    
        
        if(parseInt(scrollingStatus)==1) {
          stopScrolling = true; 
        } else {
          stopScrolling = false; 
        }
        if(type=="scroll") {
          $('#append').append(resp);
        } else {
          $('#append').html(resp);
        }
        var theSize = $('.productBox').length;
        if(theSize ==0) {
          $('.amount').hide();
        } else {
          $('.productCount').html($('.productBox').length);
        }
        
        
        $('.preloader').css('display', 'none');
        $(this).find('.wloader').css('display', 'none');
        $('.preloader').fadeOut();
        
        if (!eventBound) {
          $('.add-to-wishlist').bind('click', function () {
            product = $(this).data('product');
      
            todo = '';
            if ($(this).hasClass('active')) {
              if ($(this).hasClass('refresh')) {
                todo = "refresh";
                $(this).removeClass('active');
              } else {
                todo = "remove";
                $(this).removeClass('active');
              }
            } else {
              todo = "add";
              $(this).addClass('active');
            }
            $(this).find('.wloader').css('display', 'block');

    
            //if ($('body').hasClass('logged-in')) { // loggedin
              toggle_wishlist(product, todo);
      
            //} else {
              wishlist_localstorage(product, todo);
            //}
      
      
            return false;
          });
          eventBound = true;
        }
      }).fail(function (resp) {

      }).always(function () {

      });

    }
    toggle_filter('filter');
   
    $(window).scroll(function() {
      if (!isLoading && $(window).scrollTop() + $(window).height() >= $('#resultsList').height() - 100) {
        isLoading = true; 
   
        var paged = $('.filterHelper').data('paged');

       $('.filterHelper').data('paged', parseInt(paged)+1);
        if(!stopScrolling) {
          toggle_filter("scroll");
        }
          
      }
    }); 
} // end of filters

  if ($('.triggerCollage').length > 0) { // close collage on home page
    $('.triggerCollage').click(function () {
      $('.collageBox').slideToggle();
      return false;
    });
  }
  
  if ($('.woocommerce-MyAccount-navigation').length > 0) {
    $('.woocommerce-MyAccount-navigation a').each(function() {
      var href = $(this).attr('href');
      $(this).attr('href',href+'#info');
    });
  }
  if ($('.flexslider').length > 0) {
    $('.flexslider').flexslider({
      animation: "fade",

      directionNav: true,
      animationLoop: true,
      controlNav: true,
      pauseOnHover: false,
      prevText: "",
      nextText: "",
      start: function(slider) {
       
        slider.slides.on('scroll', function(event) {
   
            event.preventDefault(); 
        }, { passive: true });
      }
    });
  }

  if (window.location.hash) {
    // Get the target element by ID
    var targetElement = document.querySelector(window.location.hash);
    if (targetElement) {
        // Calculate the target position
        var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 200;
        
        // Smooth scroll to the target position
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
}
  $('a[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 200
        }, 1000);
        return false;
      }
    }
  });

}); 
/*
// Store scroll position in Local Storage on scroll
window.addEventListener('scroll', () => {
  // Create an array of scroll positions
  let offset = [window.pageXOffset, window.pageYOffset];

  // Stringify the array to store in Local Storage
  let offsetStr = JSON.stringify(offset);

  // Use the current URL as the key in Local Storage
  let key = document.URL;

  // Store the scroll position in Local Storage
  localStorage.setItem(key, offsetStr);
});

// Restore scroll position when the page is fully loaded
window.addEventListener('load', () => {
  // Get the saved scroll position from Local Storage
  let newOffset = localStorage.getItem(document.URL);
  console.log(newOffset);
  // Check if a saved scroll position exists
  if (newOffset) {
    try {
      // Parse the saved scroll position
      let newOffsetArr = JSON.parse(newOffset);

      // Ensure we have valid scroll values
      if (Array.isArray(newOffsetArr) && newOffsetArr.length === 2) {
        // Set the scroll position after a slight delay to ensure the content is ready
        setTimeout(() => {
          window.scrollTo(newOffsetArr[0], newOffsetArr[1]*2);
        }, 2000); // Adjust delay as needed
      }
    } catch (e) {
      console.error('Error parsing scroll position:', e);
    }
  }
});
*/
